var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImereti(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102.586,
    height: 82.59,
    viewBox: "0 0 102.586 82.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10365",
    "data-name": "Path 10365",
    d: "M75.6,9.433c5.138,4.3,7.645-2.65,10.188,1.523.885,7.8-11.12,4.817-8.784,13.359a21.628,21.628,0,0,1-6.914,10.416c.493,11.456-12.749,15.014-20.858,17.237-2.078-.754-7.047.142-8.947,1.184-5.666-.192-6.83-1.826-13.02.489-6.136-1.063-.823-10.748-7.727-9.363C9.609,41.22,10.372,32.7,4.589,36.709c-4.068.261-7.368-4.618-1.6-4.978C4.9,27.873,3.651,22.868,6.3,19.167c1.349-3.326,5.723-7.032,7.015-10.287-.03-1.345.048-3.383,1.435-4.127.61-2.852,2.172-4.892,5.3-4.527,3.641-1.694,2.385,4.265,3.008,6.328l5.89-2.018c1.4.826,3.121,1.006,4.049-.551,4.566-.191,6.784,5.326,9.233,7.993C52.111,17.546,59.412,1.865,75.6,9.433Z",
    transform: "translate(2.069 29.917) rotate(-19)",
    fill: "#23262c",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImereti);
export default __webpack_public_path__ + "static/media/imereti.116ccbd1d5f90053e40eba6dc4c2f7fd.svg";
export { ForwardRef as ReactComponent };